// extracted by mini-css-extract-plugin
module.exports = {"gridPlugWrap":"GridNoData_gridPlugWrap__pPLyP","gridPlugText":"GridNoData_gridPlugText__VMS37"};